<unity-control-wrapper [control]="$control()" [description]="$description()" [displayName]="$displayName()" [showHint]="$showHint()">
  <kendo-textarea [formControl]="$control()" />
</unity-control-wrapper>
